<template>
  <div class="content-container" v-loading="loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: parentRouter.path,
        }"
      >
        {{ parentRouter.name }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>客户详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户详情</h6> -->
    <template v-if="customer">
      <div class="quik-btns">
        <div>
          <el-button
            type="primary"
            icon="el-icon-notebook-2"
            size="small"
            @click="startCreateFollowup"
            v-permission="Auth.customerFollowUpNew"
            v-if="!customer.deleted"
            >新拜访</el-button
          >
          <router-link
            v-if="!customer.deleted"
            v-permission="
              isadealer ? Auth.orderNew : Auth.commodityOrderItemUpdate
            "
            :to="
              `/dashboard/${
                isadealer ? 'order_editor' : 'shop/orders/editor'
              }?customer=` + customerID
            "
          >
            <el-button type="primary" icon="el-icon-s-order" size="small"
              >新报价</el-button
            >
          </router-link>
          <el-button
            v-if="!customer.deleted"
            type="primary"
            icon="el-icon-money"
            size="small"
            @click="startCollectionFormer()"
            v-permission="Auth.customerCollectionNew"
            >添加回款记录</el-button
          >
        </div>
      </div>
      <div class="panel customer-info-panel mt-20">
        <div class="header customer-info-title flex-row-between">
          <span style="flex: 1">
            {{ customer.name }} {{ customer.name_en }}
            <el-tag
              size="mini"
              class="mr-5"
              :type="auth.isPlatformUser() ? 'info' : 'success'"
              v-if="customer.sap_code"
              >{{
                auth.isPlatformUser() ? customer.sap_code : '官方认证'
              }}</el-tag
            >
            <el-tag
              class="mr-5"
              size="mini"
              type="danger"
              v-if="customer.ccm == 1 && auth.isPlatformUser()"
            >
              NCR</el-tag
            >
            <!-- <el-tag size="mini" type="success" class="mr-5"
              v-if="customer.certification == 2 && auth.isPlatformUser()">已认证</el-tag> -->
            <el-tag
              size="mini"
              type="warning"
              class="mr-5"
              v-if="customer.special_mark == 1 && auth.isPlatformUser()"
              >直销客户</el-tag
            >
            <el-tag
              size="mini"
              type="warning"
              class="mr-5"
              v-else-if="customer.special_mark == 2 && auth.isPlatformUser()"
              >间销客户</el-tag
            >
            <el-tag
              size="mini"
              type="danger"
              class="ml-5"
              v-if="customer.important == 2 && auth.isPlatformUser()"
              >重点客户</el-tag
            >
          </span>
          <status-tag
            class="font-12"
            :type="customer.status == 1 ? 'success' : 'danger'"
            :name="CustomerStatusMap[customer.status]"
          ></status-tag>
        </div>
        <div class="customer-detail">
          <template v-if="auth.isPlatformUser()">
            <dl style="min-width: 60px">
              <dt>销售（服务）</dt>
              <dd>
                {{ showEmptyString(customer.platform_user.name) }}
              </dd>
            </dl>
            <dl style="min-width: 60px">
              <dt>销售（工业）</dt>
              <dd>
                {{ showEmptyString(customer.industry_sale.name) }}
              </dd>
            </dl>
            <dl style="min-width: 60px">
              <dt>销售（科学）</dt>
              <dd>
                {{ showEmptyString(customer.science_sale.name) }}
              </dd>
            </dl>
            <dl style="min-width: 60px">
              <dt>电话销售</dt>
              <dd>
                {{ showEmptyString(customer.telesale.name) }}
              </dd>
            </dl>
            <dl style="min-width: 60px">
              <dt>新品销售</dt>
              <dd>
                {{ showEmptyString(customer.new_product_sale.name) }}
              </dd>
            </dl>
            <dl style="min-width: 60px">
              <dt>客户类别</dt>
              <dd>{{ CustomerCategroyMap[customer.category] }}</dd>
            </dl>
            <dl
              style="min-width: 60px"
              v-if="hasAuth('customerMaintainanceList')"
            >
              <dt>商机潜力值</dt>
              <dd>￥{{ customer.maintainance_amount }}</dd>
            </dl>
          </template>
          <!-- <dl style="min-width: 60px" v-else>
            <dt>销售</dt>
            <dd>
              {{ showEmptyString(customer.user.name) }}
            </dd>
          </dl> -->
          <dl style="min-width: 60px" v-if="!auth.isPlatformUser()">
            <dt>行业</dt>
            <dd>
              {{ customer.industry ? customer.industry.join(' / ') : '' }}
            </dd>
          </dl>
          <dl v-if="!auth.isPlatformUser()">
            <dt>地址</dt>
            <dd>
              {{ codeToText[customer.province] }}{{ codeToText[customer.city]
              }}{{ codeToText[customer.county] }}{{ customer.address_detail }}
            </dd>
          </dl>
        </div>
        <div
          class="mt-10 flex-row-wrap"
          :class="isMobile() ? 'mobile-btns' : ''"
        >
          <template v-if="!customer.deleted">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              @click="updateCustomerFormVisible = true"
              v-permission="Auth.customerEdit"
              v-if="auth.isPlatformUser() || !customer.sap_code"
              >编辑客户信息</el-button
            >
            <el-button
              v-if="auth.isPlatformUser()"
              v-permission="Auth.customerTransfer"
              plain
              type="primary"
              icon="el-icon-top-right"
              size="small"
              @click="startTransfer('platform_user')"
              >变更销售（服务）</el-button
            >
            <el-button
              v-if="auth.isPlatformUser()"
              v-permission="Auth.customerTransfer"
              plain
              type="primary"
              icon="el-icon-top-right"
              size="small"
              @click="startTransfer('industry_sale')"
              >变更销售（工业）</el-button
            >
            <el-button
              v-if="auth.isPlatformUser()"
              v-permission="Auth.customerTransfer"
              plain
              type="primary"
              icon="el-icon-top-right"
              size="small"
              @click="startTransfer('science_sale')"
              >变更销售（科学）</el-button
            >
            <!-- <el-button v-if="!auth.isPlatformUser()" v-permission="Auth.customerTransfer" plain type="primary"
              icon="el-icon-top-right" size="small" @click="startTransfer('user')">变更销售</el-button> -->
            <el-button
              v-if="auth.isPlatformUser()"
              v-permission="Auth.customerTransfer"
              plain
              type="primary"
              icon="el-icon-top-right"
              size="small"
              @click="startTransfer('telesale')"
              >变更电话销售</el-button
            >
            <el-button
              v-if="auth.isPlatformUser()"
              v-permission="Auth.customerTransfer"
              plain
              type="primary"
              icon="el-icon-top-right"
              size="small"
              @click="startTransfer('new_product_sale')"
              >变更新品销售</el-button
            >
            <!-- <el-button v-if="auth.isPlatformUser()" v-permission="Auth.customerTransfer" plain type="primary"
              icon="el-icon-top-right" size="small" @click="startTransfer('dealer')">变更中间商</el-button> -->
          </template>
          <!-- <el-button v-if="repeat" type="primary" size="small" :icon="
            customer.certification == 2 ? 'el-icon-close' : 'el-icon-check'
          " plain @click="certificationCustomer" v-permission="Auth.customerCertification">{{
    customer.certification == 2 ? '取消认证' : '官方认证'
}}</el-button> -->
          <!-- <el-button type="primary" size="small" icon="el-icon-connection" plain @click="parentSetFormVisible = true"
            v-permission="Auth.customerParentSet">从属关系</el-button> -->
          <!-- <template v-if="auth.isPlatformUser() && customer.sap_code">
            <el-popconfirm
              v-permission="Auth.customerSystemStatus"
              class="ml-10"
              :title="`确认${statusText(
                customer.system_status
              )}该客户使用此系统的权限吗？`"
              @confirm="handleSwtichStatus()"
            >
              <el-button slot="reference" type="danger" size="small" plain>
                {{ statusText(customer.system_status) }}
              </el-button>
            </el-popconfirm>
          </template> -->
          <template v-if="auth.isPlatformUser() || !customer.sap_code">
            <el-button
              v-if="!customer.deleted"
              class="ml-10"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              @click="deleteCustomer"
              v-permission="Auth.customerDelete"
              >删除</el-button
            >
            <el-button
              v-else
              type="success"
              size="small"
              icon="el-icon-magic-stick"
              plain
              @click="recoveryCustomer"
              v-permission="Auth.customerRecovery"
              >恢复</el-button
            >
          </template>
        </div>
      </div>
      <div class="panel mt-20">
        <el-tabs v-if="isadealer" v-model="activeTab" @tab-click="clickedTab">
          <el-tab-pane
            label="总览"
            name="tab1"
            v-if="hasAuth('customerOverview')"
          ></el-tab-pane>
          <el-tab-pane
            :label="'设备(' + detail_overview.device_count + ')'"
            name="tab4"
            v-if="hasAuth('customerDeviceList')"
          ></el-tab-pane>
          <el-tab-pane
            :label="'服务请求(' + detail_overview.service_quest_count + ')'"
            name="tab11"
            v-if="hasAuth('serviceQuestDealerList')"
          ></el-tab-pane>
          <!-- <el-tab-pane
            :label="'报价单(' + detail_overview.quotation_count + ')'"
            name="tab3"
            v-if="hasAuth('quotationList')"
          ></el-tab-pane> -->
          <el-tab-pane
            :label="'报价单(' + detail_overview.order_count + ')'"
            name="tab2"
            v-if="hasAuth('orderList')"
          ></el-tab-pane>
          <el-tab-pane
            label="收款记录"
            name="tab7"
            v-if="hasAuth('customerCollectionList')"
          ></el-tab-pane>
          <el-tab-pane
            label="费用流水"
            name="tab6"
            v-if="hasAuth('customerFeeList')"
          ></el-tab-pane>
          <el-tab-pane
            :label="'拜访记录(' + detail_overview.visit_count + ')'"
            name="tab8"
            v-if="hasAuth('customerFollowUpList')"
          ></el-tab-pane>
          <el-tab-pane label="基本信息" name="tab5"></el-tab-pane>
          <el-tab-pane label="动态" name="tab9"></el-tab-pane>
        </el-tabs>
        <el-tabs v-else v-model="activeTab" @tab-click="clickedTab">
          <el-tab-pane
            :label="'设备(' + detail_overview.device_count + ')'"
            name="tab4"
            v-if="hasAuth('customerDeviceList')"
          ></el-tab-pane>
          <el-tab-pane
            :label="'最终客户(' + detail_overview.customer_count + ')'"
            name="tab13"
            v-if="
              isDealerCustomer(customer.category) && hasAuth('finalCustomer')
            "
          ></el-tab-pane>
          <el-tab-pane
            :label="'服务请求(' + detail_overview.service_quest_count + ')'"
            name="tab11"
            v-if="hasAuth('serviceQuestList')"
          ></el-tab-pane>
          <el-tab-pane
            :label="'报价单(' + detail_overview.order_count + ')'"
            name="tab2"
            v-if="hasAuth('orderList') || hasAuth('commodityOrderList')"
          ></el-tab-pane>
          <el-tab-pane
            label="商机潜力"
            name="tab17"
            v-if="hasAuth('customerMaintainanceList')"
          ></el-tab-pane>
          <el-tab-pane
            label="发货记录"
            name="tab15"
            v-if="hasAuth('customerDeviceDeliveryList')"
          ></el-tab-pane>
          <el-tab-pane
            label="拜访记录"
            name="tab8"
            v-if="hasAuth('customerFollowUpList')"
          ></el-tab-pane>
          <el-tab-pane
            label="客户联系人"
            name="tab10"
            v-if="hasAuth('customerContactorList')"
          ></el-tab-pane>
          <el-tab-pane
            label="ShipTo联系人"
            name="tab16"
            v-if="hasAuth('customerContactorList')"
          ></el-tab-pane>
          <el-tab-pane
            label="信息上报"
            name="tab14"
            v-if="hasAuth('customerIssueList')"
          ></el-tab-pane>
          <el-tab-pane label="基本信息" name="tab5"></el-tab-pane>
          <el-tab-pane
            label="登录管理"
            name="tab12"
            v-if="
              isDealerCustomer(customer.category) && hasAuth('customerSetting')
            "
          ></el-tab-pane>
          <el-tab-pane label="动态" name="tab9"></el-tab-pane>
        </el-tabs>
      </div>
      <template v-if="activeTab == 'tab1'">
        <overview-tab
          :customer="customer"
          :customerID="customerID"
        ></overview-tab>
      </template>
      <CustomerList
        v-if="activeTab == 'tab13'"
        :dealerID="customer.id"
      ></CustomerList>
      <template v-else-if="activeTab == 'tab10'">
        <contact-tab
          :customerID="customerID"
          :customerDeleted="customer.deleted"
        ></contact-tab>
      </template>
      <template v-else-if="activeTab == 'tab11'">
        <service-quest-tab
          :customerID="customerID"
          :deviceID="parseInt($route.query.device_id || 0)"
        ></service-quest-tab>
      </template>
      <template v-else-if="activeTab == 'tab2'">
        <order-tab :customerID="customerID" v-if="isadealer"></order-tab>
        <CommodityOrderTab :customerID="customerID" v-else></CommodityOrderTab>
      </template>
      <!-- <template v-else-if="activeTab == 'tab3'">
        <quotation-tab
          :customerID="customerID"
          :customerDeleted="customer.deleted"
        ></quotation-tab>
      </template> -->
      <template v-else-if="activeTab == 'tab4'">
        <customer-device-tab
          :customerID="customerID"
          :fixedCustomer="customer"
          :topPage="false"
          :customerDeleted="customer.deleted"
        ></customer-device-tab>
      </template>
      <template v-else-if="activeTab == 'tab5'">
        <div class="panel mt-20">
          <div class="header flex-row-between">
            <h2>基本信息</h2>
            <el-button
              type="primary"
              size="small"
              v-if="auth.isPlatformUser() || !customer.sap_code"
              @click="updateCustomerFormVisible = true"
              v-permission="Auth.customerEdit"
              >编辑</el-button
            >
          </div>
          <ul class="base-info">
            <template v-if="isadealer">
              <li>
                <span class="title">中文名：</span>
                <span>{{ customer.name }}</span>
              </li>
              <li>
                <span class="title">英文名：</span>
                <span>{{ customer.name_en }}</span>
              </li>
              <li>
                <span class="title">地址：</span>
                <span>{{ customer.address_detail }}</span>
              </li>
              <li>
                <span class="title">行业：</span>
                <span>{{
                  customer.industry ? customer.industry.join(' / ') : ''
                }}</span>
              </li>
              <li>
                <span class="title">规模：</span>
                <span>{{ customer.scale }}</span>
              </li>
              <li>
                <span class="title">来源：</span>
                <span>{{ customer.source }}</span>
              </li>
            </template>
            <template v-else>
              <li>
                <span class="title">中文名：</span>
                <span>{{ customer.name }}</span>
              </li>
              <li>
                <span class="title">英文名：</span>
                <span>{{ customer.name_en }}</span>
              </li>
              <li>
                <span class="title">SAP Code：</span>
                <span>{{ customer.sap_code }}</span>
              </li>
              <li>
                <span class="title">C4C ID：</span>
                <span>{{ customer.c4c_id || '' }}</span>
              </li>
              <li v-if="customer.category == 6">
                <span class="title">代理商：</span>
                <span>{{ customer.dealer_customer.name }}</span>
              </li>
              <li v-if="customer.category == 6">
                <span class="title">售后服务销售商：</span>
                <span>{{ customer.service_customer.name }}</span>
              </li>
              <li>
                <span class="title">区域：</span>
                <span>{{ AreaTextMap[customer.area_id] }}</span>
              </li>
              <li>
                <span class="title">地区：</span>
                <span>
                  {{ codeToText[customer.province]
                  }}{{ codeToText[customer.city]
                  }}{{ codeToText[customer.county] }}
                </span>
              </li>
              <li>
                <span class="title">地址：</span>
                <span>{{ customer.address_detail }}</span>
              </li>
              <li>
                <span class="title">行业：</span>
                <span>{{
                  customer.industry ? customer.industry.join(' / ') : ''
                }}</span>
              </li>
              <li>
                <span class="title">规模：</span>
                <span>{{ customer.scale }}</span>
              </li>
              <li>
                <span class="title">来源：</span>
                <span>{{ customer.source }}</span>
              </li>
              <li>
                <span class="title">代理人：</span>
                <span>{{ customer.agent_name }}</span>
              </li>
              <li>
                <span class="title">代理人手机号：</span>
                <span>{{ customer.agent_mobile }}</span>
              </li>
              <li>
                <span class="title">最终用途：</span>
                <span>{{ customer.usages.split(',').join('，') }}</span>
              </li>
              <li>
                <span class="title">级别（服务）：</span>
                <span>{{ customer.service_stage.name }}</span>
              </li>
              <li>
                <span class="title"
                  >小程序可见商品PH<CustomTip :t="1"></CustomTip>：</span
                >
                <span>{{
                  customer.mp_visible_phs
                    ? customer.mp_visible_phs.join(' / ')
                    : '无'
                }}</span>
              </li>
              <!-- <li>
                <span class="title">级别（工业）：</span>
                <span>{{ customer.industry_stage.name }}</span>
              </li>
              <li>
                <span class="title">级别（科学）：</span>
                <span>{{ customer.science_stage.name }}</span>
              </li> -->
              <template v-if="isDealerCustomer(customer.category)">
                <li>
                  <span class="title">授权服务商：</span>
                  <span>{{ customer.is_fix_dealer == 1 ? '是' : '否' }}</span>
                </li>
                <li>
                  <span class="title">邮箱：</span>
                  <span>{{ customer.email }}</span>
                </li>
                <li>
                  <span class="title">OM邮箱：</span>
                  <span>{{ customer.om_email }}</span>
                </li>
                <li>
                  <span class="title">EC有效期：</span>
                  <span>{{
                    customer.ec_deadline
                      ? $time(customer.ec_deadline).format('YYYY年M月D日')
                      : ''
                  }}</span>
                </li>
              </template>
            </template>
          </ul>
        </div>
        <div class="panel mt-20" v-permission="Auth.customerInvoiceList">
          <div class="header flex-row-between">
            <h2>发票信息</h2>
            <el-button
              v-if="!customer.deleted"
              type="primary"
              size="small"
              @click="startCustomerInvoiceFormer()"
              >编辑发票</el-button
            >
          </div>
          <ul class="base-info" v-if="invoices.length > 0">
            <li>
              <span class="title">发票抬头：</span>
              <span>{{ invoices[0].title }}</span>
            </li>
            <li>
              <span class="title">纳税识别号：</span>
              <span>{{ invoices[0].tax_number }}</span>
            </li>
            <li>
              <span class="title">开户行：</span>
              <span>
                {{ invoices[0].bank_name }}
              </span>
            </li>
            <li>
              <span class="title">银行账号：</span>
              <span>{{ invoices[0].bank_account }}</span>
            </li>
            <li>
              <span class="title">注册地址：</span>
              <span>{{ invoices[0].address }}</span>
            </li>
            <li>
              <span class="title">收票人姓名：</span>
              <span>{{ invoices[0].consignee_name }}</span>
            </li>
            <li>
              <span class="title">收票人电话：</span>
              <span>{{ invoices[0].consignee_mobile }}</span>
            </li>
            <li>
              <span class="title">收票人邮箱：</span>
              <span>{{ invoices[0].consignee_email }}</span>
            </li>
            <li>
              <span class="title">收票地址：</span>
              <span>{{ invoices[0].consignee_address }}</span>
            </li>
          </ul>

          <!-- <el-table
            v-if="!isMobile()"
            :data="invoices"
            stripe
            style="width: 100%"
            header-row-class-name="q-products-header"
            key="invoices"
          >
            <el-table-column prop="title" label="企业名称"></el-table-column>
            <el-table-column
              prop="tax_number"
              label="纳税识别号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="bank_name"
              label="开户行/账号"
              align="center"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.bank_name }}</div>
                <div>{{ scope.row.bank_account }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="发票邮寄地址"
            ></el-table-column>
            <el-table-column align="right" label="操作" width="80">
              <template slot-scope="scope">
                <div class="flex-row-between">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="startCustomerInvoiceFormer(scope.row, scope.$index)"
                    v-permission="Auth.customerInvoiceEdit"
                    >修改</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <ul v-else class="list-style">
            <li v-for="(item, index) in invoices" class="flex-row-between">
              <div>
                <div>{{ item.title }}</div>
                <div class="font-12">税号：{{ item.tax_number }}</div>
                <div class="font-12">
                  银行：{{ item.bank_name }} {{ item.bank_account }}
                </div>
                <div class="font-12">地址：{{ item.address }}</div>
              </div>
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCustomerInvoiceFormer(item, index)"
                v-permission="Auth.customerInvoiceEdit"
                >修改</el-button
              >
            </li>
          </ul> -->
        </div>
      </template>
      <template v-else-if="activeTab == 'tab6'">
        <expend-tab :customerID="customerID" ref="expendTab"></expend-tab>
      </template>
      <template v-else-if="activeTab == 'tab7'">
        <collection-tab
          :customerID="customerID"
          ref="collectionTab"
        ></collection-tab>
      </template>
      <template v-else-if="activeTab == 'tab8'">
        <visit-tab :customer="customer" ref="visitTab"></visit-tab>
      </template>
      <template v-else-if="activeTab == 'tab14'">
        <issue-tab :customerID="customerID" ref="issueTab"></issue-tab>
      </template>
      <template v-else-if="activeTab == 'tab12'">
        <SetTab v-if="activeTab == 'tab12'" :usage="customer.usage"></SetTab>
      </template>
      <template v-else-if="activeTab == 'tab9'">
        <log-tab :customerID="customerID"></log-tab>
      </template>
      <template v-else-if="activeTab == 'tab15'">
        <DeliveryTab :customerID="customerID" :topPage="false"></DeliveryTab>
      </template>
      <template v-else-if="activeTab == 'tab16'">
        <ShipContactTab :customerID="customerID"></ShipContactTab>
      </template>
      <template v-else-if="activeTab == 'tab17'">
        <MaintainanceTab :customerID="customerID"></MaintainanceTab>
      </template>
      <customer-former
        :model="customerForm"
        :show.sync="updateCustomerFormVisible"
        @updatedCustomer="updatedCustomer"
      ></customer-former>
      <followup-former
        :model="followUpForm"
        :show.sync="createFollowupFormVisible"
        @created="createdFollowup"
      ></followup-former>
      <customer-invoice-former
        :model="customerInvoiceForm"
        :show.sync="createCustomerInvoiceFormVisible"
        @created="createdCustomerInvoice"
        @updated="updatedCustomerInvoice"
      ></customer-invoice-former>
      <customer-collection-former
        :model="customerCollectionForm"
        :customerID="customerID"
        :show.sync="customerCollectionFormVisible"
        @created="createdCustomerCollection"
      ></customer-collection-former>
      <customer-transfer
        :model="customerTransferForm"
        :show.sync="customerTransferVisible"
        @updated="updateCustomerUser"
      ></customer-transfer>
      <parent-former
        :model="parentCustomerForm"
        :show.sync="parentSetFormVisible"
        @updatedCustomer="updatedCustomer"
      ></parent-former>
    </template>
  </div>
</template>

<script>
import CustomerFormer from '@/components/customer'
import CustomerInvoiceFormer from '@/components/customer_invoice'
import CustomerCollectionFormer from '@/components/customer_collection'
import CustomerTransfer from '@/components/customer_transfer'
import CustomerDeviceTab from '@/views/customer_device/index'
import DeliveryTab from '@/views/customer_device/delivery'
import FollowupFormer from '@/components/followup'
import ContactTab from './contact'
import ShipContactTab from './ship_contact'
import MaintainanceTab from './maintainance'
import IssueTab from './issue'
import CustomerList from '@/views/customer/index'
import OrderTab from './order'
import CommodityOrderTab from './commodity_order'
import QuotationTab from './quotation'
import OverviewTab from './overview'
import CollectionTab from './collection'
import VisitTab from '../../views/visit/index'
import SetTab from './set'
import ExpendTab from './expend'
import LogTab from './log'
import ServiceQuestTab from './service_quest'
import ParentFormer from './parent_set'
import { hasAuth } from '@/permission'

import { CutomerLogTypes, CustomerLogMap, AreaTextMap } from '@/config/global'

import { formatTime, isMobile } from '@/util/index'
import { clone, showEmptyString } from '@/util'
import auth from '@/util/auth'
import { CustomerStatusMap, CustomerCategroyMap } from '@/config/global'

import {
  customerDetail,
  customerContactList,
  customerLogList,
  customerDeviceList,
  customerInvoiceList,
  quotationList,
  updateQuotaionStatus,
  deleteQuotation,
  customerOrderList,
  customerCollectionList,
  deleteCustomer,
  certificationCustomer,
  recoveryCustomer,
} from '../../service/getData'
import { CodeToText } from '@/util/area_tool'
import store from '@/store/store'

export default {
  components: {
    CustomerFormer,
    CustomerInvoiceFormer,
    CollectionTab,
    FollowupFormer,
    CustomerCollectionFormer,
    CustomerTransfer,
    VisitTab,
    ContactTab,
    ShipContactTab,
    MaintainanceTab,
    IssueTab,
    ExpendTab,
    CustomerDeviceTab,
    OrderTab,
    CommodityOrderTab,
    QuotationTab,
    OverviewTab,
    LogTab,
    SetTab,
    CustomerList,
    ServiceQuestTab,
    ParentFormer,
    DeliveryTab,
  },
  data() {
    return {
      hasAuth,
      showEmptyString,
      codeToText: CodeToText,
      AreaTextMap,
      CustomerStatusMap,
      activeTab: null,
      customerID: parseInt(this.$route.params.id),
      customer: null,
      isMobile,
      loading: false,
      CustomerLogMap,
      CustomerCategroyMap,
      userInfo: store.getters.userInfo,
      isadealer: store.getters.userInfo.dealer_id > 0,
      customerForm: {},
      updateCustomerFormVisible: false,
      createFollowupFormVisible: false,
      createCustomerInvoiceFormVisible: false,
      createCustomerContactFormVisible: false,
      customerCollectionFormVisible: false,
      customerTransferVisible: false,
      logs: [],
      auth,
      customerForm: {
        name: null,
        contact_name: null,
        contact_mobile: null,
        address: null,
      },
      parentSetFormVisible: false,
      customerContactForm: {
        name: '',
        duty: '',
        mobile: '',
        email: '',
      },
      detail_overview: {
        order_count: 0,
        quotation_count: 0,
        contact_count: 0,
        device_count: 0,
        visit_count: 0,
        service_quest_count: 0,
      },
      customerTransferForm: {},
      quotations: [],
      orders: [],
      device: [],
      contacts: [],
      devices: [],
      invoices: [],
      followups: [],
      origin: null,
      customerRate: 4.3,
      addCustomerVisible: false,
      dateRange: null,
      followUpForm: {
        customer_id: parseInt(this.$route.params.id),
        type: 1,
        date: null,
        next_date: null,
        amount: '',
        target_id: 0,
        quotation_id: 0,
        content: '',
        customer_contact_id: '',
      },
      logRequest: {
        type: 0,
        sort: 0,
        page: 1,
        size: 10,
      },
      logTotal: 0,
      logTypes: CutomerLogTypes,
      collections: [],
      customerInvoiceForm: {},
      customerCollectionForm: {},
      editDeviceIndex: -1,
      editInvoiceIndex: -1,
      editContactIndex: -1,
      formatTime: formatTime,
      repeat: false,
    }
  },
  computed: {
    parentCustomerForm() {
      return {
        id: this.customer.id || 0,
        name: this.customer.name || '',
        parent_id: this.customer.parent_id || 0,
        status: this.customer.status || 0,
      }
    },
    parentRouter() {
      if (this.customer == null) {
        return {
          name: '',
          path: '',
        }
      }

      let path = !this.customer.deleted
        ? '/dashboard/customers'
        : '/dashboard/customers/deleted'
      let name = !this.customer.deleted ? '客户管理' : '已删除客户'

      if (this.$route.name == 'customerRepeat') {
        this.repeat = true
        name = '重复客户'
        path = '/dashboard/customers/repeat'
      }
      return {
        name: name,
        path: path,
      }
    },
  },
  watch: {
    'logRequest.page': function () {
      this.requestCustomerLogList()
    },
    $route() {
      let id = parseInt(this.$route.params.id)
      if (id != this.customerID) {
        this.customerID = id
        this.activeTab = null
        setTimeout(this.ready, 50)
      }
    },
  },
  // beforeRouteUpdate(to, from, next) {
  //   console.log(1333444433)
  //   if (parseInt(to.params.id) != this.customerID) {
  //     this.customerID = parseInt(to.params.id)
  //     this.activeTab = null
  //     setTimeout(this.ready, 50)
  //   }
  //   next()
  // },
  created() {
    this.ready()
  },
  methods: {
    ready() {
      if (this.isadealer) {
        this.activeTab = this.$route.query.tab || 'tab1'
      } else {
        this.activeTab = this.$route.query.tab || 'tab4'
      }
      this.requestCustomer()
      this.requestCustomerInvoices()
    },
    async requestCustomer() {
      this.loading = true
      let res = await customerDetail(this.customerID)
      if (res.code == 0) {
        this.customer = res.data
        this.customerForm = clone(res.data)
        // this.customerForm.special_mark = this.customerForm.special_mark == 1
        this.detail_overview = res.data.detail_overview
        this.loading = false
      } else {
        this.$router.go(-1)
      }
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      this.contacts = res.data.list
    },
    async requestCustomerLogList() {
      let data = {
        page: this.logRequest.page - 1,
        size: this.logRequest.size,
        sort: this.logRequest.sort,
        type: this.logRequest.type,
        customer_id: this.customerID,
      }
      let res = await customerLogList(data)
      this.logTotal = res.data.total
      this.logs = res.data.list.map((log) => {
        log.title = CustomerLogMap[log.type]
        var links = []
        if (log.links.length > 0) {
          let array = log.links.split(';')
          links = array.map((item) => {
            return this.logLink(item)
          })
        }
        log.links = links
        return log
      })
    },
    async requestCustomerDevies() {
      let res = await customerDeviceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.devices = res.data.list
    },
    async requestCustomerInvoices() {
      let res = await customerInvoiceList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.invoices = res.data.list
    },
    async requestCustomerCollections() {
      let res = await customerCollectionList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.collections = res.data.list
    },
    async requestCustomerQuotations() {
      let res = await quotationList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      this.quotations = res.data.list
    },
    async requestCustomerOrders() {
      let res = await customerOrderList({
        page: 0,
        size: 1000,
        customer_id: this.customerID,
      })
      if (res.code == 0) {
        this.orders = res.data.list
      }
    },
    submitOrder(index) {
      let that = this
      this.$confirm('是否确定提交转化订单申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateQuotaionStatus({ id: that.quotation.id }).then((res) => {
          if (res.code == 0) {
            that.quotations[index].status = res.data.status
          }
        })
      })
    },
    canModify(status) {
      return status == 1 || status == 3
    },
    logParams(k, v) {
      let v1,
        v2 = ''
      if (v.length > 0) {
        v1 = v[0]
      }
      if (v.length > 1) {
        v2 = v[1]
      }
      if (k == '省' || k == '市' || k == '区/县') {
        v1 = this.codeToText[v1]
        v2 = this.codeToText[v2]
      } else if (k.indexOf('时间') != -1) {
        v1 = formatTime(v1)
        v2 = formatTime(v2)
      }
      return k + '：' + v1 + ' -> ' + v2
    },
    startCreateFollowup() {
      this.followUpForm = {
        customer_id: this.customerID,
        type: 1,
        date: new Date(),
        next_date: null,
        amount: '',
        quotation_id: null,
        content: '',
        pics: [],
        customer_contact_id: null,
      }
      this.createFollowupFormVisible = true
    },
    startCustomerInvoiceFormer(invoice, index) {
      if (this.invoices.length > 0) {
        this.customerInvoiceForm = clone(this.invoices[0])
        this.editInvoiceIndex = 0
      } else {
        this.customerInvoiceForm = {
          customer_id: this.customerID,
          title: '',
          bank_name: '',
          bank_account: '',
          tax_number: '',
          address: '',
          consignee_name: '',
          consignee_mobile: '',
          consignee_email: '',
          consignee_address: '',
        }
      }

      this.createCustomerInvoiceFormVisible = true
    },

    startCollectionFormer() {
      this.customerCollectionForm = {
        customer_id: this.customerID,
        amount: '',
        date: null,
      }

      this.customerCollectionFormVisible = true
    },
    deleteCustomer() {
      this.$prompt('请输入删除原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{2}/,
        inputErrorMessage: '请至少输入2个字',
      })
        .then(({ value }) => {
          let that = this
          deleteCustomer({
            id: this.customer.id,
            reason: value,
          }).then((res) => {
            if (res.code == 0) {
              that.customer.deleted = 1
              that.$message.success('删除成功')
              that.$router.push(
                '/dashboard/customers/deleted/' + that.customer.id,
              )
              if (this.isadealer) {
                this.activeTab = 'tab1'
              } else {
                this.activeTab = 'tab4'
              }
            }
          })
        })
        .catch(() => {})
    },

    certificationCustomer() {
      let str =
        this.customer.certification == 2
          ? '确定取消该客户的认证吗？'
          : '确定认证该客户吗？'
      this.$confirm(str).then((res) => {
        certificationCustomer({ id: this.customer.id }).then((res) => {
          if (res.code == 0) {
            this.customer.certification = res.data
          }
        })
      })
    },
    recoveryCustomer() {
      this.$prompt('请输入恢复原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{2}/,
        inputErrorMessage: '请至少输入2个字',
      })
        .then(({ value }) => {
          let that = this
          recoveryCustomer({
            id: that.customer.id,
            reason: value,
          }).then((res) => {
            if (res.code == 0) {
              that.customer.deleted = 0
              that.$message.success('恢复成功')
              that.$router.push('/dashboard/customers/' + that.customer.id)
              if (this.isadealer) {
                this.activeTab = 'tab1'
              } else {
                this.activeTab = 'tab4'
              }
            }
          })
        })
        .catch(() => {})
    },
    startTransfer(type) {
      let form = {
        target_id: null,
        customer_id: this.customer.id,
        type: type,
      }
      this.customerTransferForm = form
      this.customerTransferVisible = true
    },
    updatedCustomer(customer) {
      this.customer = customer
      this.customerForm = clone(customer)

      this.requestCustomer()
      // this.customerForm.special_mark = this.customerForm.special_mark == 1
      this.requestCustomerLogList()
    },
    createdFollowup(follow) {
      if (this.$refs.visitTab) {
        this.$refs.visitTab.refresh()
      }
      if (this.$refs.expendTab) {
        this.$refs.expendTab.refresh()
      }
    },
    createdCustomerDevcice(customerDevice) {
      this.devices.unshift(customerDevice)
      this.requestCustomerLogList()
    },
    updatedCustomerDevcice(customerDevice) {
      this.devices.splice(this.editDeviceIndex, 1, customerDevice)
      this.requestCustomerLogList()
    },
    createdCustomerInvoice(invoice) {
      this.invoices.unshift(invoice)
      this.requestCustomerLogList()
    },
    updatedCustomerInvoice(invoice) {
      this.invoices.splice(this.editInvoiceIndex, 1, invoice)
      this.requestCustomerLogList()
    },
    createdCustomerCollection() {
      if (this.$refs.collectionTab) {
        this.$refs.collectionTab.refresh()
      }
    },
    updateCustomerUser(customer) {
      if (
        customer.user_id != this.userInfo.id &&
        !hasAuth('customerTransfer')
      ) {
        this.$router.push('/dashboard/customers')
        return
      }
      this.customer = customer
      this.requestCustomerLogList()
    },
    handleTabClick() {},
    logLink(lnk) {
      let links = lnk.split('|')
      let text = links[0]
      let linkInfo = links[1]
      let infos = linkInfo.split(':')
      let url = ''
      if (infos[0] == 'quotation') {
        url = '/dashboard/quotations/' + infos[1]
      } else if (infos[0] == 'amount') {
        url = ''
      } else if (infos[0] == 'order') {
        url = '/dashboard/dealer/orders/' + infos[1]
      }
      return {
        text: text,
        url: url,
      }
    },
    submitApproval(index) {
      let q = this.quotations[index]
      let that = this
      this.$confirm('是否确定提交审批?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateQuotaionStatus({ id: q.id }).then((res) => {
          if (res.code == 0) {
            q.status = res.data.status
          }
        })
      })
    },
    deleteQuotation(index) {
      let q = this.quotations[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuotation(q.id).then((res) => {
          if (res.code == 0) {
            that.quotations.splice(index, 1)
          }
        })
      })
    },
    clickedTab(e) {
      this.$router.replace({ query: { tab: e.name } })
    },
  },
}
</script>

<style scoped>
.customer-info-panel {
  color: #6e6446;
}

.customer-info-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #3e3221;
}

.customer-detail dl {
  margin: 0;
}

.customer-detail {
  display: flex;
  justify-content: space-between;
}

.customer-detail dt {
  display: block;
  color: #adb5bd;
  line-height: 1.8;
  font-size: 12px;
}

.customer-detail dd {
  display: block;
  font-size: 14px;
  line-height: 1.3;
  margin: 0;
}

h4 {
  font-size: 14px;
  color: #3e3221;
}

.actions {
  padding-top: 10px;
  box-sizing: border-box;
}

.actions button {
  margin-right: 6px;
  margin-top: 10px;
}

.customer {
  backg-color: #fff;
  padding: 20px 12px;
}

.customer-name {
  font-size: 18px;
  color: #333;
  padding: 0;
  line-height: 20px;
}

.customer .title,
.device .title {
  display: flex;
  justify-content: space-between;
}

.info li {
  color: #666;
  font-size: 12px;
}

.device {
  margin-top: 12px;
  padding: 20px 12px;
}

.info {
  font-weight: normal;
}

.filter {
  font-size: 12px;
  color: #777;
}

.filter label {
  margin: 0 4px;
}

.customer-data {
  display: flex;
  margin-top: 10px;
  border-top: 1px dotted #ddd;
  padding-top: 10px;
}

.customer-data li {
  width: 25%;
  text-align: left;
}

.customer-data li span {
  display: block;
  color: #0087cb;
}

.customer-data li span.title {
  color: #909399;
  line-height: 2;
}

.yuce li {
  color: #666;
  margin-bottom: 12px;
  padding-top: 12px;
  font-size: 12px;
  border-top: 1px dotted #ddd;
}

.yuce li:first-child {
  border-top: 0 none;
}

.text-tips {
  color: #999;
  font-size: 12px;
  margin: 0;
  margin-top: 10px;
}

.log-tag {
  margin-right: 4px;
}

.el-checkbox__label {
  font-size: 12px;
}

.overview .sub-info {
  border: 0 none;
}

.overview .sub-info-value {
  font-size: 20px;
  font-weight: 400;
}

.base-info {
  display: flex;
  flex-wrap: wrap;
}

.base-info li {
  width: 50%;
  padding-top: 10px;
}

.base-info .title {
  color: #999;
}

.quik-btns {
  margin-top: 10px;
  margin-bottom: 20px;
}

.quik-btns div {
  display: flex;
  flex-wrap: wrap;
}

.quik-btns div button {
  margin-top: 10px;
  margin-right: 10px;
  margin-left: 0;
}

.quik-btns h4 {
  font-size: 12px;
  color: #adb5bd;
  font-weight: normal;
}

.mobile-btns {
  margin-top: 0 !important;
  justify-content: space-between;
}

.mobile-btns .el-button {
  margin-top: 10px;
}

.mobile-btns .el-button + .el-button {
  margin-left: 0;
}
</style>

<style  scoped>
@media (max-width: 767px) {
  .customer-detail dl {
    margin: 0;
    display: flex;
    align-items: center;
    padding: 3px 0;
  }

  .customer-detail {
    flex-direction: column;
  }

  .customer-detail dt {
    color: #adb5bd;
    line-height: 1.8;
    font-size: 12px;
    margin-right: 10px;
  }

  .customer-detail dd {
    font-size: 12px;
    line-height: 1.3;
  }
}
</style>